import React from "react";
import classnames from "classnames";
import moment from "moment";
import connect from "Shared/connect";
import { translate } from "Shared/translate";
import { getStepSize } from "Shared/Quantity/utils";
import { replaceStringWithElement } from "Shared/replace-strings-with-element";
import * as styles from "./base.scss";
import MyMenigoIcon from "./../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import VariantAndQuantity from "Shared/ProductCard/VariantAndQuantity";
const debounceMs = 400;
class SubDeliveryRow extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.updateDebouncer = (quantity) => {
            clearTimeout(this.currentTimeout);
            return new Promise(() => {
                this.currentTimeout = setTimeout(() => {
                    this.props
                        .update(quantity)
                        .then((resolve) => resolve)
                        .catch((reject) => reject);
                }, debounceMs);
            });
        };
        this.getSelectedVariant = () => this.props.selectedVariant || this.props.variants[0];
        this.showSubDelivery = () => !this.props.punchOutSessionActive &&
            this.props.date.substring(0, 10) !== "0001-01-01";
        this.getFormattedDeliveryDate = () => moment(this.props.date).format("YYYY-MM-DD");
    }
    render() {
        const { quantity, remove, isLineItemPending, date, originalPrice, product, isCheckout, } = this.props;
        const selectedVariant = this.getSelectedVariant();
        const step = getStepSize(selectedVariant);
        const round = (num, precision) => Number(Math.round(Number(num + "e+" + precision)) + "e-" + precision);
        const price = !!selectedVariant.price && !!selectedVariant.price.current && !!quantity
            ? selectedVariant.price.current * quantity +
                (!!originalPrice && !!originalPrice.current
                    ? originalPrice.current
                    : 0)
            : -1;
        const priceRounded = round(price, 2);
        return this.showSubDelivery() ? (React.createElement("div", { className: classnames(styles.subDeliveryWrapper, {
                [styles.isMobile]: this.props.isMobile,
            }) },
            React.createElement("div", { className: styles.top },
                React.createElement("div", { className: styles.info },
                    React.createElement("div", { className: classnames(styles.date, styles["description--medium"]) },
                        React.createElement("div", null, translate("/Checkout/NewDeliveryDate")),
                        React.createElement("div", null, this.getFormattedDeliveryDate())),
                    React.createElement("div", { className: styles.label }, translate("/Checkout/SubDelivery"))),
                React.createElement("div", { className: styles.actions },
                    React.createElement("div", { className: styles.quantity },
                        React.createElement(VariantAndQuantity, { product: product, index: this.props.index, updateCartQuantity: this.updateDebouncer, quantityStep: step, quantityInCart: quantity, minQuantity: 0, isCartQuantity: true, variants: product.variants, selectedVariant: selectedVariant, isWeightProduct: product.isWeightProduct, isRestrictedCustomer: false, discontinuedOrBackordered: false, disableBuyWidgets: !product.isBuyable || product.isSoldOut, url: "", useNewDesign: true, isCheckout: isCheckout })),
                    React.createElement("div", { className: styles.remove, onClick: () => remove() },
                        React.createElement(MyMenigoIcon, { name: "trash" })))),
            React.createElement("div", { className: classnames(styles.bottom, styles.title) }, price >= 0
                ? `${priceRounded.toLocaleString("sv-SE")} ${originalPrice.currencySymbol}`
                : ""))) : (React.createElement("div", { className: classnames(styles.subDeliveryWrapper, {
                [styles.loading]: isLineItemPending,
            }) },
            React.createElement("div", { className: styles.infoText }, date.substring(0, 10) === "0001-01-01"
                ? translate("/Checkout/NotValidDeliveryDate")
                : replaceStringWithElement(translate("/Checkout/PunchoutSubDeliveryText", "{date}"), "{date}", () => (React.createElement("span", { className: styles.punchoutDate }, this.getFormattedDeliveryDate()))))));
    }
}
export default connect((state) => ({
    punchOutSessionActive: state.currentUser.punchOutSessionActive,
}))(SubDeliveryRow);
